import React from 'react';
import { useNavigate, useLocation } from 'react-router-dom';
import { LayoutDashboard, Box, Scan, Settings, FolderOpen, Video } from 'lucide-react';
import { cn } from '../lib/utils';
import { useAuth } from '../context/AuthContext';

const MobileNav = ({ onScanClick }) => {
  const navigate = useNavigate();
  const location = useLocation();
  const { isAdmin } = useAuth();

  const navItems = [
    { icon: LayoutDashboard, label: 'Start', path: '/' },
    { icon: Box, label: 'Container', path: '/containers' },
    { icon: Scan, label: 'Scannen', path: '/', primary: true },
    { icon: FolderOpen, label: 'Ordner', path: '/folders' },
    { icon: Video, label: 'Videos', path: '/videos' },
  ];

  return (
    <nav className="mobile-nav md:hidden" data-testid="mobile-nav">
      <div className="flex justify-around items-center">
        {navItems.map((item) => {
          const Icon = item.icon;
          const isActive = item.path && location.pathname === item.path && !item.primary;
          
          if (item.primary) {
            return (
              <button
                key={item.label}
                onClick={() => navigate('/')}
                className="flex flex-col items-center justify-center -mt-6"
                data-testid="mobile-nav-scan-btn"
              >
                <div className="w-14 h-14 bg-emerald-600 rounded-full flex items-center justify-center shadow-lg pulse-scan">
                  <Icon className="h-6 w-6 text-white" />
                </div>
                <span className="text-xs mt-1 text-emerald-600 font-medium">{item.label}</span>
              </button>
            );
          }

          return (
            <button
              key={item.label}
              onClick={() => item.action ? item.action() : navigate(item.path)}
              className={cn(
                'flex flex-col items-center justify-center py-2 px-3 min-w-[60px]',
                isActive ? 'text-emerald-600' : 'text-slate-400'
              )}
              data-testid={`mobile-nav-${item.label.toLowerCase()}-btn`}
            >
              <Icon className="h-5 w-5" />
              <span className="text-xs mt-1">{item.label}</span>
            </button>
          );
        })}
      </div>
    </nav>
  );
};

export default MobileNav;
